import * as React from 'react';

import type { IconProps } from './types';

export const ImageError = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M297.45.035C111.094.035 0 111.132 0 297.485V726.51c0 55.803 9.727 104.44 28.67 145.394 7.049 15.51 15.455 29.814 24.904 43.063l-41.85 41.873c-15.358 15.359-15.358 40.447 0 55.804a38.787 38.787 0 0 0 12.74 8.446 38.785 38.785 0 0 0 29.972-.276 38.8 38.8 0 0 0 12.58-8.683l945.082-945.08c15.87-15.36 15.87-39.932 0-55.291-15.36-15.36-40.447-15.36-55.805 0l-41.498 41.52C866.175 18.545 802.668.034 726.473.034H297.449zm.001 76.795h429.024c54.071 0 98.657 10.635 133.125 31.676L235.693 732.75l-140.98 94.615C83.45 798.697 76.795 765.418 76.795 726.51V297.484c0-144.372 76.283-220.654 220.656-220.654zm706.405 96.762-62.461 62.459c4.096 18.944 5.632 39.42 5.632 61.433v245.657l-6.554-5.545c-19.98-17.163-46.111-25.736-72.239-25.725-26.127-.011-52.258 8.562-72.238 25.725l-212.973 182.77c-18.171 15.61-41.59 24.186-65.455 25.532-23.842 1.325-48.124-4.558-68.066-17.853l-.04.039c-.02-.014-.041-.025-.062-.04L173.965 1003.48c.025.012.05.012.076.025l-.486.486c36.195 13.256 77.482 19.89 123.326 19.946.16 0 .309.021.469.021H726.473c186.352 0 297.449-111.094 297.449-297.447V297.484c0-46.077-6.656-87.544-19.967-123.892l-.074.074-.025-.074zm-645.43 11.826a121.841 121.841 0 0 0-86.158 35.69 121.84 121.84 0 0 0 0 172.316 121.836 121.836 0 0 0 86.158 35.687A121.85 121.85 0 0 0 480.27 307.266a121.852 121.852 0 0 0-35.687-86.159 121.841 121.841 0 0 0-86.158-35.689z"
        fill={color}
      />
    </svg>
  )
);

export default ImageError;
